import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as TorrentIcon } from "./torrent-icon.svg";

const Torrent = (props: any) => {
  return (
    <SvgIcon component={ TorrentIcon } {...props} />
  );
}

export default Torrent;